<template>
<Container 
  :navItems="navItems" 
  :breadcrumb-list="list" 
  :name="name" 
  :feature-tour-link="featureTourLink"  
>
  <template >
    <router-view v-if="$Session"></router-view>
    <div v-if="!$Session" slot="body" style="height: 300px; display: flex; align-items: center; justify-content: center;">
        <b-spinner label="Loading" variant="primary"></b-spinner>
    </div>
  </template>

</Container>
</template>

<script>
import {Container} from '@campbell-cloud/vue-container'
import AppConfig from '../../app.config';

export default {
  name: 'DefaultContainer',
  components: {
    Container
  },
  data () {
    return {
      navItems : [],
      featureTourLink: AppConfig.tour_url
    }
  },
  methods: {
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {     
      const matched = this.$route.matched.filter((route) => route.name || route.meta.label );
      this.$ccI18n.preprocessRouterBreadcrumb.call(this, matched);
      return matched;
    },
  },
  watch: {
  },
  created() {
    
  },
}
</script>

<style>
.empty-info-message {
    color: gray;
    font-size: small;
}
.scroll-container-sm{
    max-height: 7em;
    overflow-y: auto;
}
.scroll-container-md{
    max-height: 12em;
    overflow-y: auto;
}
.scroll-container-lg{
    max-height: 18em;
    overflow-y: auto;
    padding-top:0.5em;
}

button.fa.fa-floppy-o.aside-primary-button:hover{
  color: #3a5f8e;
}
</style>
